import React, { FC, useContext } from 'react';
import { CustomerLiveFetcher } from '../../fetchers/CustomerLiveFetcher';
import { LivePreviewContent } from '../CloudLive/CloudLive';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { Link } from 'react-router-dom';
import { CustomerNewLiveStack } from './CustomerNewLiveStack';
import { LiveRegionSelect } from '../LiveRegionSelect/LiveRegionSelect';
import { LiveRegionContext, LiveRegionContextProvider } from '../../contexts/LiveRegionContext';
import { LiveRegionsFetcher } from '../../fetchers/LiveRegionsFetcher';
import { useTranslation } from 'react-i18next';
import { useDialog } from '../../hooks/useDialog';
import { OrganizationContext } from '../../contexts/OrganizationContext';
import { apiCloudLive } from '../../resources/api/apiCloudLive';

const { useCreateLiveStack } = apiCloudLive;

const Content: FC = () => {
  const { data, onRefresh } = useContext(CustomerLiveFetcher.Context);

  return <Box marginTop={1}>{data ? <LivePreviewContent stacks={data} onRefresh={onRefresh} /> : null}</Box>;
};

const CustomerLiveContent: FC = () => {
  const { t } = useTranslation();

  const { organization } = useContext(OrganizationContext);
  const { region } = useContext(LiveRegionContext);

  const { isOpen: isCreatingNew, openUrl: newUrl, close: abortNew } = useDialog('new');

  const { Guard: GuardCreate } = useCreateLiveStack(organization ?? void 0, region);

  return (
    <LiveRegionsFetcher.WAF>
      <Grid container spacing={1}>
        <Grid item xs={12} md={4} lg={2}>
          <LiveRegionSelect />
        </Grid>
        <Grid item xs={12} md={8} lg={10}>
          <GuardCreate>
            <Button component={Link} to={newUrl} variant="contained" color="primary">
              {t('organization.live.addButton')}
            </Button>
          </GuardCreate>
        </Grid>
      </Grid>

      <CustomerLiveFetcher.WAF>
        <Content />
      </CustomerLiveFetcher.WAF>

      <CustomerNewLiveStack open={isCreatingNew} closeDialog={abortNew} />
    </LiveRegionsFetcher.WAF>
  );
};

export const CustomerLive: FC = () => {
  return (
    <LiveRegionContextProvider>
      <CustomerLiveContent />
    </LiveRegionContextProvider>
  );
};
